import React, {useEffect, useState} from 'react';
import Placeholder from "../Placeholder";
import {apiFetch, formatNumber, parseCurrency} from 'utils';
import ExportControls from "../shared/ExportControls";
import {withRouter} from 'react-router';

const KeyFeatureReport = ({location}) => {

  const [report, setReport] = useState({});

  const token = $('meta[name="csrf-token"]').attr('content');
  useEffect(() => {
    apiFetch.get({}, 'reporting/key_feature_report')
      .then((json) => {
        setReport(json)
      })
  }, [])

  const columns = {
    "name": 'string',
    "last_login": 'string',
    "active_users": 'number',
    "events_scheduled": 'number',
    "reports_created": 'number',
    "sms_sent": 'number',
    "quick_filters_added": 'number',
    "crm_notes": 'number',
    "candidate_review": 'string',
    "autocomm_triggers": 'string',
    "custom_email_templates": 'number'
  }

  return (
    <Placeholder.loading
      ready={Object.keys(report).length > 0}
      content={() => (
        <div className={'reporting'}>
          <h2>Key Feature Adoption Report
            <ExportControls location={location}
                            async={false}
                            url={"/api/reporting/key_feature_report/export"}/>
            <div className={'border-header'}/>
          </h2>

          <div style={{marginTop: '20px'}}>
            <table className={'table table-striped'}>
              <thead>
              <tr className={'bold'}>
                <td>School</td>
                <td>Last Login</td>
                <td>Active Users</td>
                <td>Events Scheduled</td>
                <td>Reports Created</td>
                <td>SMS Sent</td>
                <td>Filters Added</td>
                <td>Notes/Activities</td>
                <td>Candidate Review Enabled</td>
                <td>Communication Plans Enabled</td>
                <td>Custom Email Templates</td>
              </tr>
              </thead>
              <tbody>
              {Object.keys(report).map((key) => {
                  return (
                    <tr>
                      {Object.keys(columns).map((column) => (
                        <td>
                          <a target='_blank' href={column === 'name' ? "http://" + report[key]['domain'] + "/admin" : null}>
                            {columns[column] === 'number' ? formatNumber(report[key][column]) : String(report[key][column])}
                          </a>
                        </td>))}
                    </tr>)
                }
              )}
              </tbody>
            </table>
          </div>

        </div>
        )}
    />
  );
}

export default withRouter(KeyFeatureReport);